import { BehaviorSubject } from 'rxjs';
import { debugAdd } from '~src/helpers/debug';
import DbViewport from '~src/models/DbViewport';

export const viewport$ = new BehaviorSubject<DbViewport>({});

debugAdd({ viewport$ });

export default viewport$;